.cover-holder {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 0.4rem;
  border-radius: 0.6rem;
  overflow: hidden;
}

.image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  box-shadow: none;
  cursor: pointer;
  border-radius: 0.6rem;
}

.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  color: lightgray;
  font-size: 2.4rem;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  border-radius: 0.6rem;
  z-index: 1;
  /* Purely an affordance — it has no handlers of its own, and it must never take the pointer
     from what it covers. Capturing drag events here would also fire dragleave on the holder
     the moment this appeared, flickering it back off. */
  pointer-events: none;

  &[data-show='true'] {
    opacity: 1;
  }
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 10;
  opacity: 0;
  /* At opacity 0 this still covers the whole cover and would swallow every click on anything
     stacked over it. Only take the pointer while actually shown, where blocking interaction
     during an upload is the point. */
  pointer-events: none;

  & svg {
    color: #cacdd5;
  }

  & span {
    color: #cacdd5;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
  }

  &[data-show='true'] {
    opacity: 1;
    pointer-events: auto;
  }
}

/* Empty state for consumers that pass `placeholderIcon`: a flat grey field with the resource's
   own glyph centred. Deliberately inert — the cover is changed from the card's menu, not by
   clicking here. The icons hardcode their own width/height and Person hardcodes a path fill,
   so both have to be overridden rather than inherited. */
.icon-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: 0.6rem;
  background-color: var(--color-surface-tertiary);

  svg {
    width: 4.8rem;
    height: 4.8rem;
  }

  svg,
  svg path {
    fill: var(--color-grey-5);
  }
}
